import { QueryResult, gql, useLazyQuery, useQuery } from '@apollo/client';

const GET_PAYLOAD_QUERY = gql`
  query getDecryptedPayload($payload: String!) {
    getDecryptedPayload(payload: $payload) {
      payload
    }
  }
`;

export const SIGNED_URL_QUERY = gql`
  query signedTenantBucketUrl($url: String!) {
    signedTenantBucketUrl(url: $url)
  }
`;

interface DecryptedPayloadOutput {
  getDecryptedPayload: {
    payload: string;
  };
}

type DecryptedPayloadInput = {
  payload: string;
};

function useDecryptedPayloadQuery(
  variables: DecryptedPayloadInput,
): QueryResult<DecryptedPayloadOutput, DecryptedPayloadInput> {
  return useQuery<DecryptedPayloadOutput, DecryptedPayloadInput>(
    GET_PAYLOAD_QUERY,
    { variables },
  );
}

export type SignedBucketUrlOutput = {
  signedTenantBucketUrl: string;
};

type SignedBucketUrlInput = {
  url: string;
};

function useSignedBucketUrlLazyQuery() {
  return useLazyQuery<SignedBucketUrlOutput, SignedBucketUrlInput>(
    SIGNED_URL_QUERY,
  );
}

export type { DecryptedPayloadOutput };
export { useDecryptedPayloadQuery, useSignedBucketUrlLazyQuery };
